import classNames from "classnames";
import React, { useEffect, useState } from "react";
import Heading from "../../elements/heading";
import ResetPasswordConfirmation from "../../sections/reset-password-confirmation";
import ResetPasswordForm from "../../sections/reset-password-form";
import Modal from "../Modal";
import "./style.scss";
import { getOverallSettingsClasses, getOverallSettingsStyles } from "../../utils/siteUtils";

export default function ResetPassword({ open, onCloseClicked, sendResetPasswordLink, fields }) {
  const {
    headingType,
    headingBody,
    body,
    formHeadingType,
    formHeadingBody,
    formBody,
    emailLabel,
    emailWarningMessage,
    emailMissingMessage,
    emailNotExistMessage,
    maxRequestReachedMessage,
    ctaNamePassword,
    // ctaTypePassword,
    colorSchemePassword,
    iconNamePassword,
    sendLinkFailedMessage,
    confirmHeadingType,
    confirmHeadingBody,
    confirmBody,
    ctaNameLink,
    ctaTypeLink,
    colorSchemeLink,
    iconNameLink,
    link,
    email,
    className,
    id,
    urlParam
  } = fields;
  const [submitedEmail, setSubmitedEmail] = useState(email);
  const [isInConfirmationStep, setIsInConfirmationStep] = useState(false);
  
  useEffect(() => {
    setSubmitedEmail(email);
  }, [email]);
  const onCloseClickedInner = () => {
    setTimeout(() => {
      setSubmitedEmail(null);
      setIsInConfirmationStep(false);
    }, 10);
    onCloseClicked && onCloseClicked();
  };
  const overallSettingsStyles = getOverallSettingsStyles(fields);
  const overallSettingsClasses = getOverallSettingsClasses(fields);
  const resetPasswordClassNames = classNames("reset-password", className);
  const resetPasswordFormProps = {
    headingType: formHeadingType,
    headingBody: formHeadingBody,
    body: formBody,
    email: submitedEmail,
    emailLabel: emailLabel,
    emailWarningMessage,
    emailMissingMessage,
    emailNotExistMessage,
    maxRequestReachedMessage,
    sendLinkFailedMessage,
    sendResetPasswordLink,
    submitButton: {
      buttonText: ctaNamePassword.value,
      iconName: iconNamePassword,
      colorScheme: colorSchemePassword
    },
    onNextStep: email => {
      setSubmitedEmail(email);
      setIsInConfirmationStep(true);
      let newUrl = "";
      if (window.location.search.includes(`?modal=${urlParam.value}`)) {
        newUrl = window.location.href.replace(`?modal=${urlParam.value}`, "");
      } else if (window.location.search.includes(`&modal=${urlParam.value}`)) {
        newUrl = window.location.href.replace(`&modal=${urlParam.value}`, "");
      } else {
        
        newUrl = window.location.href.replace(`modal=${urlParam.value}`, "");
      }
  
      window.history.replaceState(null, null, newUrl);
    }
  };
  const resetPasswordConfirmationProps = {
    headingType: confirmHeadingType,
    headingBody: confirmHeadingBody,
    body: confirmBody,
    emailNotExistMessage,
    maxRequestReachedMessage,
    sendLinkFailedMessage,
    sendResetPasswordLink,
    email: submitedEmail,
    resendButton: {
      ctaType: ctaTypeLink,
      buttonText: ctaNameLink.value,
      iconName: iconNameLink,
      colorScheme: colorSchemeLink,
      link: link
    }
  };
  return (
    <Modal className={resetPasswordClassNames} modalContentClasses={overallSettingsClasses} modalContentStyles={overallSettingsStyles} showModal={open} onCloseClicked={onCloseClickedInner} id={id}>
      <Heading type={headingType} className="title show-on-scroll" html={headingBody} typographyClass="type-h1" />

      {body && (
        <div
          className={"body-text"}
          dangerouslySetInnerHTML={{
            __html: body.value
          }}
        />
      )}

      {!isInConfirmationStep && <ResetPasswordForm {...resetPasswordFormProps} />}
      {isInConfirmationStep && <ResetPasswordConfirmation {...resetPasswordConfirmationProps} />}
    </Modal>
  );
}
